import React, { useEffect, useState } from 'react'
import { ApexCharts, LoadingCard, MsgSemRegistros } from '../../../../Components'
import { Card, CardBody, Col } from 'reactstrap'
import { CardTitle } from '../styles'
import { LogAcessoGetEvolucaoPosts } from '../../../../Service/ApiService'

let initChart = {
  series: [
    { name: 'Views', type: 'column', data: [] },
    { name: 'Posts', type: 'line', data: [] },
    { name: 'Likes', type: 'column', data: [] },
  ],
  options: {
    chart: { height: 243, type: 'line', stacked: false, toolbar: { show: false } },
    stroke: { width: [1, 4, 1] },
    plotOptions: { bar: { columnWidth: '50%' } },
    xaxis: { categories: [], type: 'datetime', labels: { format: 'dd MMM' } },
    yaxis: [
      { min: 0, seriesName: 'Views', show: true },
      { min: 0, seriesName: 'Posts', opposite: true, show: false },
      { seriesName: 'Likes', opposite: true, show: false },
    ],
    tooltip: { shared: true, intersect: false, x: { format: 'dd MMM yyyy' } },
    responsive: [{ breakpoint: 450, options: { chart: { width: 350 }, legend: { position: 'bottom' } } }],
  },
}

const MixedGraph = ({ filters }) => {
  const [confChart, setConfChart] = useState(initChart)
  const [msgId, setMsgId] = useState(1)

  async function loadData() {
    setMsgId(1)
    try {
      const response = await LogAcessoGetEvolucaoPosts(filters)
      if (response.labels?.length > 0) {
        let _confChart = { ...initChart }
        _confChart.series[0].data = response.views
        _confChart.series[1].data = response.posts
        _confChart.series[2].data = response.likes

        _confChart.options.xaxis.categories = response.labels

        setConfChart(_confChart)
        setMsgId(2)
      } else setMsgId(3)
    } catch {
      setMsgId(3)
    }
  }

  useEffect(() => {
    if (filters) loadData()
  }, [filters])

  return (
    <Card className="main-card mb-2">
      <CardBody>
        <CardTitle>Evolução diária de likes, views e posts</CardTitle>

        {
          {
            1: (
              <Col md="12" className="text-center">
                <LoadingCard isVisible={true} />
              </Col>
            ),
            2: <ApexCharts options={confChart.options} series={confChart.series} type="line" height={208} />,
            3: <MsgSemRegistros />,
          }[msgId]
        }
      </CardBody>
    </Card>
  )
}

export default MixedGraph
